import { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { MdAdd, MdArrowBackIos, MdOutlineCancel } from "react-icons/md";
import CreateTag from "../../Admin/SharedTeamTags/CreateTag";
import { useQuery } from "@apollo/client";
import { GET_TAGS } from "../../../apollo/Queries";
import { useSelector } from "react-redux";
import { useUpload } from "../../../context/UploadContext";
// import { useParams } from "react-router-dom";
import { IoClose } from "react-icons/io5";

const FileUploadTags = ({ setUploadStep, type, tag_list = [], upload_type = '', ...otherProps }) => {
    // const params = useParams()
    const { selected_ids, setSelected_ids } = useUpload()
    const { user, active_conversation } = useSelector(state => state.message)
    const [tab_state] = useState('public');
    const [loader, setLoader] = useState(true)
    // const [task_tag, set_task_tag] = useState([]);
    // const [isLengthCheck, setIsLengthCheck] = useState(false);
    const [all_tags, setAll_tags] = useState([]);

    const colorCode = ['#032e84', '#732BE2', '#078CFE', '#28C8BD', '#FF991D', '#FFE026'];

    const [assignedTags] = useState([{ id: 0, name: "CHECK", color: colorCode[0] }]);
    const [search, setSearch] = useState("");

    // const addTag = (tag) => {
    //     if (!assignedTags.some((t) => t.id === tag.id)) {
    //         setAssignedTags([...assignedTags, tag]);
    //     }
    // };

    // const removeTag = (tagId) => {
    //     setAssignedTags(assignedTags.filter((t) => t.id !== tagId));
    // };


    const handleClosePopup = () => {
        setUploadStep("upload");
    };

    useQuery(GET_TAGS, {
        variables: { company_id: user.company_id, upload_type: upload_type },
        fetchPolicy: 'no-cache',
        onCompleted: (res) => {
            if (res) {
                let tags = [...res.tags.private, ...res.tags.public];
                let taskTag = (otherProps.from && otherProps.from === '#TASK')
                    ? res.tags.task_tag.filter(f => f.title === otherProps.from)
                    : res.tags.task_tag;

                setAll_tags(tags);
                // set_task_tag(taskTag);

                if (tag_list.length > 0) {
                    setSelected_ids(tag_list);
                }

                if (type === 'file' || type === 'file_upload') {
                    // let old_tag = action_file?.tag_list || [];
                    let conv_tags = active_conversation?.tag_list || [];
                    let taskTagIds = taskTag.map(m => m.tag_id);
                    setSelected_ids([...taskTagIds, ...conv_tags]);
                }
                setLoader(false);
            }
        }
    });

    const removeFromMini = (item) => {
        setSelected_ids(selected_ids.filter(f => f !== item.tag_id))
        // setChangesMade(true);
    }

    const select_tag = (tag) => {
        if (selected_ids.includes(tag.tag_id)) {
            setSelected_ids(selected_ids.filter(f => f !== tag.tag_id))
        } else {
            setSelected_ids([...selected_ids, tag.tag_id])
        }
        // setChangesMade(true);
    }

    useEffect(() => {
        // setIsLengthCheck(selected_ids.length > 0 ? true : false);
    }, [selected_ids])


    const minidiv = all_tags.filter(f => selected_ids?.includes(f.tag_id)).map((item, i) =>
        <div key={'_mini_' + i} className="rounded flex gap-2 items-center px-3 py-1.5 text-white text-xs" style={{ backgroundColor: item.tag_color }}>
            <p>{item.title}</p>
            {(item.title !== '#TASK-COST' && item.title !== '#TASK') && <MdOutlineCancel className="cursor-pointer" onClick={() => removeFromMini(item)} size={16} />}
        </div>
    )

    const [createTagsPopup, setCreateTagsPopup] = useState('');

    return (
        <>
            <div>
                <header className="filterFileHeader !h-[50px] dark:bg-teal-900">
                    <div onClick={handleClosePopup} className="allfilterFileHeader items-center -mt-1">
                        <MdArrowBackIos className="allFileHeaderIcon thread_eHeaderIcon text-2xl -mt-1" />
                        <div className='mt-1'>
                            <span className="allFileHeaderText ">Assign tag(s) to the file</span>
                        </div>
                    </div>
                </header>
                <div className="px-5 pt-5 rounded-lg relative  ">
                    <div className="flex gap-3 items-center dark:bg-teal-900">
                        <div className="bg-gray-100 rounded relative w-[100%]">
                            <input
                                className="px-3 py-2 w-full bg-gray-100 border border-teal-200 rounded text-teal-600  dark:bg-teal-900  dark:text-white"
                                type="text"
                                placeholder="Search tag"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            {
                                search ? <IoClose onClick={() => setSearch('')} className="text-gray-500 absolute right-3 top-2 text-2xl cursor-pointer" /> : <BiSearch className="text-gray-500 absolute right-3 top-2 text-2xl cursor-pointer" />
                            }
                            {/* <BiSearch className="text-gray-500 absolute right-3 top-2 text-2xl cursor-pointer" /> */}
                            {/* {search &&
                                <IoClose onClick={() => setSearch('')} className="text-text-body absolute right-12 top-2 text-xl cursor-pointer" />
                            } */}
                        </div>
                    </div>
                    {
                        selected_ids.length > 0 &&
                        <div className=" border-b border-gray-300 w-full pb-4 pt-4 ">
                            <p className="mb-2 text-text-body dark:text-white">Assigned tag(s)</p>
                            <div className="max-h-[96px] mmin-h-[65px] overflow-auto">
                                <div className="flex flex-wrap gap-1.5">
                                    {minidiv}
                                </div>
                            </div>
                        </div>
                    }

                    <div className={`my-4 ${assignedTags.length > 0 ? "h-[calc(100vh-360px)]" : assignedTags.length === 0 ? "h-[calc(100vh-215px)]" : ""}  overflow-auto`}>
                        {loader ? (
                            <div className="btn_loader leftbar_loader !h-[300px]"></div>
                        ) : (
                            (() => {
                                const filteredTags = all_tags.filter(f => !["#TASK-COST", "#TASK", "UNTAGGED FILES"].includes(f.title)).filter(f =>
                                    f.title.toLowerCase().trim().includes(search.toLowerCase().trim()) && f.tag_type === tab_state && !selected_ids.includes(f.tag_id)
                                );

                                return filteredTags.length > 0 ? (
                                    filteredTags.map((v, i) => (
                                        <div key={i}
                                            className="cursor-pointer rounded bg-gray-100 flex gap-1 items-center px-2 py-2 mb-2 hover:bg-gray-300 dark:bg-teal-900"
                                            onClick={() => { select_tag(v); setSearch(''); }}
                                        >
                                            <div className="rounded-full border-2 w-4 h-4" style={{ backgroundColor: v.tag_color }}></div>
                                            <p className="text-sm text-teal-600 dark:text-white">{v.title}</p>
                                        </div>
                                    ))
                                ) : (
                                    <div className="relative mt-28">
                                        <div>
                                            <p className="text-center text-gray-500 dark:text-white mt-40">No tags found</p>
                                            <p className="text-center text-gray-500 dark:text-white mt-40">Please create new tags</p>
                                        </div>
                                        <div className="flex justify-center mt-5" onClick={() => setCreateTagsPopup(true)}>
                                            <button className="bg-teal-600 flex justify-center items-center gap-1 text-white py-2 px-5 text-sm rounded-full text-center" >
                                                <MdAdd className="text-xl" />
                                                Create a tag
                                            </button>
                                        </div>

                                    </div>
                                );
                            })()
                        )}
                    </div>

                </div>
            </div>
            <CreateTag isOpen={createTagsPopup} onClose={setCreateTagsPopup} all_tags={all_tags} setAll_tags={setAll_tags} search={search} setSearch={setSearch} select_tag={select_tag} />
        </>
    );
};

export default FileUploadTags;